export enum videoSiteNeededKeys {
  aspectRatio = 'aspectRatio',
  contentSelector = 'contentSelector',
  defaultVtt = 'defaultVtt',
  domain = 'domain',
  mobilePopoutPlacement = 'mobilePopoutPlacement',
  mobilePopoutTopMargin = 'mobilePopoutTopMargin',
  sidebarSelector = 'sidebarSelector',
  stickyContentSide = 'stickyContentSide',
  videoAdhesionBackground = 'videoAdhesionBackground',
  videoAdhesionLightTheme = 'videoAdhesionLightTheme',
  youtubeChannelId = 'youtubeChannelId'
}
